import { useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import siteLogo from "../../Assets/Images/site_logo.png";
import { drawPrescription } from "./DrawPrescription";

const PrescriptionPDF = forwardRef(({ data }, ref) => {
    const canvasRef = useRef(null);
    useImperativeHandle(ref, () => ({ getCanvas: () => canvasRef.current }));
    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        drawPrescription(ctx, canvas, data, siteLogo);
    }, [data]);

    return (
        <canvas
            ref={canvasRef}
            width={600}
            height={800}
            style={{ border: "1px solid #ccc" }}
        />
    )
});

export default PrescriptionPDF;
